import styled from 'styled-components';

export const ContainerTotais = styled.div`
  display: grid;
  gap: 20px;
  align-self: center;
  grid-template-columns: repeat(auto-fill, minmax(195px, 1fr));
  margin-top: 1.6rem;

  @media (max-width: 880px) {
    grid-template-columns: repeat(2, minmax(206px, 1fr));
  }
`;
